const hi = {
  'English': 'अंग्रेज़ी',
  'Hindi': 'हिंदी',
  'Marathi': 'मराठी',
  'Dashboard': 'डैशबोर्ड',
  'Network': 'नेटवर्क',
  'Leads': 'लीड्स',
  'Learning Center': 'लर्निंग सेंटर',
  'Platform Tour': 'प्लेटफ़ॉर्म टूर',
  'About Us': 'हमारे बारे में',
  'Offline': 'ऑफ़लाइन',
  'Notifications': 'सूचनाएं',
  'Notifications ({count} unread)': 'सूचनाएं ({count} अपठित)',
  'Loading notifications...': 'सूचनाएं लोड हो रही हैं...',
  'No new notifications': 'कोई नई सूचना नहीं',
  'Mark all as read': 'सभी को पढ़ा हुआ चिह्नित करें',
  'Hi, {name}': 'नमस्ते, {name}',
  'My Profile': 'मेरी प्रोफ़ाइल',
  'Scan Attendance QR': 'उपस्थिति QR स्कैन करें',
  'Android App': 'एंड्रॉयड ऐप',
  'Settings': 'सेटिंग्स',
  'Platform Invoices': 'प्लेटफ़ॉर्म इनवॉइस',
  'Convert To Customer': 'ग्राहक में बदलें',
  'Force Refresh App': 'ऐप को पुनः लोड करें',
  'Logout': 'लॉगआउट',
  'This will clear all cached data and refresh the app. Continue?': 'इससे सारा कैश डेटा हटेगा और ऐप फिर से लोड होगा। जारी रखें?',
  'Preparing Android app download...': 'एंड्रॉयड ऐप डाउनलोड की तैयारी हो रही है...',
  'Downloading Android app... {percent}%': 'एंड्रॉयड ऐप डाउनलोड हो रहा है... {percent}%',
  'Downloading Android app...': 'एंड्रॉयड ऐप डाउनलोड हो रहा है...',
  'Android app download started.': 'एंड्रॉयड ऐप डाउनलोड शुरू हो गया है।',
  'Android app download timed out. Please try again.': 'एंड्रॉयड ऐप डाउनलोड का समय समाप्त हो गया। कृपया फिर से प्रयास करें।',
  'Failed to download Android app. Please try again.': 'एंड्रॉयड ऐप डाउनलोड नहीं हो सका। कृपया फिर से प्रयास करें।',
  'Install CalorieNSweat App': 'CalorieNSweat ऐप इंस्टॉल करें',
  'Add to your home screen for quick access': 'तेज़ पहुंच के लिए इसे होम स्क्रीन पर जोड़ें',
  'Later': 'बाद में',
  'Install': 'इंस्टॉल करें',
  'Built with affection': 'स्नेहपूर्वक निर्मित',
  'by': 'द्वारा',
  'Welcome, {name}!': 'स्वागत है, {name}!',
  'Reset Password': 'पासवर्ड रीसेट करें',
  'Email Address': 'ईमेल पता',
  'Email Address or Username': 'ईमेल पता या यूज़रनेम',
  'Enter email or username': 'ईमेल या यूज़रनेम दर्ज करें',
  'Enter your email address': 'अपना ईमेल पता दर्ज करें',
  'Password': 'पासवर्ड',
  'Hide password': 'पासवर्ड छुपाएँ',
  'Show password': 'पासवर्ड दिखाएँ',
  'Please complete the reCAPTCHA verification': 'कृपया reCAPTCHA सत्यापन पूरा करें',
  'reCAPTCHA not available on localhost. This is normal for development.': 'localhost पर reCAPTCHA उपलब्ध नहीं है। विकास के लिए यह सामान्य है।',
  'reCAPTCHA verification failed. Please refresh the page and try again.': 'reCAPTCHA सत्यापन विफल हुआ। कृपया पेज रीफ्रेश करें और फिर से प्रयास करें।',
  'Login': 'लॉगिन',
  'Logging in...': 'लॉगिन हो रहा है...',
  'Forgot Password?': 'पासवर्ड भूल गए?',
  'Forgot your password?': 'क्या आप अपना पासवर्ड भूल गए?',
  'Contact your administrator for account access': 'खाते की पहुंच के लिए अपने व्यवस्थापक से संपर्क करें',
  'By using CalorienSweat, you agree to our:': 'CalorienSweat का उपयोग करके, आप हमारी इन बातों से सहमत हैं:',
  'Privacy Policy': 'गोपनीयता नीति',
  'Terms of Service': 'सेवा की शर्तें',
  'Signing in...': 'साइन इन हो रहा है...',
  'Sign In': 'साइन इन',
  'Sending...': 'भेजा जा रहा है...',
  'Send Reset Link': 'रीसेट लिंक भेजें',
  'Back to Login': 'लॉगिन पर वापस जाएँ',
  'Invalid or missing reset token.': 'रीसेट टोकन अमान्य है या अनुपस्थित है।',
  'Invalid or expired reset token.': 'रीसेट टोकन अमान्य है या समाप्त हो चुका है।',
  'Passwords do not match.': 'पासवर्ड मेल नहीं खाते।',
  'Password must be at least 6 characters long.': 'पासवर्ड कम से कम 6 अक्षरों का होना चाहिए।',
  'Failed to reset password. Please try again.': 'पासवर्ड रीसेट नहीं हो सका। कृपया फिर से प्रयास करें।',
  'Invalid Reset Link': 'अमान्य रीसेट लिंक',
  'Request New Reset Link': 'नया रीसेट लिंक मांगें',
  'Password Reset Successful!': 'पासवर्ड रीसेट सफल रहा!',
  'Your password has been successfully reset. You will be redirected to the login page in a few seconds.': 'आपका पासवर्ड सफलतापूर्वक रीसेट हो गया है। कुछ सेकंड में आपको लॉगिन पेज पर भेज दिया जाएगा।',
  'Go to Login': 'लॉगिन पर जाएँ',
  'Verifying reset link...': 'रीसेट लिंक सत्यापित किया जा रहा है...',
  'Set New Password': 'नया पासवर्ड सेट करें',
  'New Password': 'नया पासवर्ड',
  'Enter new password (min 6 characters)': 'नया पासवर्ड दर्ज करें (कम से कम 6 अक्षर)',
  'Confirm New Password': 'नए पासवर्ड की पुष्टि करें',
  'Confirm new password': 'नए पासवर्ड की पुष्टि करें',
  'Resetting...': 'रीसेट किया जा रहा है...',
  'If your email is registered with us, you will receive a password reset link.': 'यदि आपका ईमेल हमारे साथ पंजीकृत है, तो आपको पासवर्ड रीसेट लिंक प्राप्त होगा।',
  'Reports': 'रिपोर्ट्स',
  'Please select both start and end dates': 'कृपया प्रारंभ और समाप्ति दोनों तिथियाँ चुनें',
  'Date range cannot exceed more than one year': 'तिथि सीमा एक वर्ष से अधिक नहीं हो सकती',
  'Start date cannot be after end date': 'प्रारंभ तिथि समाप्ति तिथि के बाद नहीं हो सकती',
  'Failed to generate report. Please try again.': 'रिपोर्ट जनरेट नहीं हो सकी। कृपया फिर से प्रयास करें।',
  'Failed to generate attendance report. Please try again.': 'उपस्थिति रिपोर्ट जनरेट नहीं हो सकी। कृपया फिर से प्रयास करें।',
  'Failed to generate profit report. Please try again.': 'लाभ रिपोर्ट जनरेट नहीं हो सकी। कृपया फिर से प्रयास करें।',
  'Failed to export attendance report. Please try again.': 'उपस्थिति रिपोर्ट एक्सपोर्ट नहीं हो सकी। कृपया फिर से प्रयास करें।',
  'No data to export': 'एक्सपोर्ट करने के लिए कोई डेटा नहीं है',
  'Reports Dashboard': 'रिपोर्ट्स डैशबोर्ड',
  'Generate detailed reports for your business analysis': 'अपने व्यवसाय विश्लेषण के लिए विस्तृत रिपोर्ट जनरेट करें',
  'Available Reports': 'उपलब्ध रिपोर्ट्स',
  'Invoice Reports': 'इनवॉइस रिपोर्ट्स',
  'Generate detailed invoice reports with payment information, GST breakdown, and volume points': 'भुगतान जानकारी, GST विवरण और वॉल्यूम पॉइंट्स के साथ विस्तृत इनवॉइस रिपोर्ट जनरेट करें',
  'Attendance Reports': 'उपस्थिति रिपोर्ट्स',
  'Generate monthly attendance reports for your club customers': 'अपने क्लब ग्राहकों के लिए मासिक उपस्थिति रिपोर्ट जनरेट करें',
  'Profit Reports': 'लाभ रिपोर्ट्स',
  'Analyze profit margins and volume points distribution across products and programs': 'प्रोडक्ट्स और प्रोग्राम्स के बीच लाभ मार्जिन और वॉल्यूम पॉइंट्स वितरण का विश्लेषण करें',
  'More Reports Coming Soon': 'और रिपोर्ट्स जल्द आ रही हैं',
  'Additional report types will be added in future updates': 'भविष्य के अपडेट में अतिरिक्त रिपोर्ट प्रकार जोड़े जाएंगे',
  'Invoice Report Generator': 'इनवॉइस रिपोर्ट जनरेटर',
  'Program Invoice': 'प्रोग्राम इनवॉइस',
  'Product Invoice': 'प्रोडक्ट इनवॉइस',
  'GST will not be charged or shown because your company GSTIN is not configured.': 'आपकी कंपनी का GSTIN कॉन्फ़िगर नहीं है, इसलिए GST न तो लिया जाएगा और न दिखाया जाएगा।',
  'Maximum shipping charges allowed: ₹300. GST will not be charged.': 'अधिकतम शिपिंग शुल्क ₹300 है। GST नहीं लिया जाएगा।',
  'Generating...': 'जनरेट हो रहा है...',
  'Generate Report': 'रिपोर्ट जनरेट करें',
  'Export CSV': 'CSV एक्सपोर्ट करें',
  'Note: Date range cannot exceed more than one year': 'नोट: तिथि सीमा एक वर्ष से अधिक नहीं हो सकती',
  'Invoice Report Results ({count} entries)': 'इनवॉइस रिपोर्ट परिणाम ({count} प्रविष्टियाँ)',
  'Period': 'अवधि',
  'Invoice ID': 'इनवॉइस ID',
  'Invoice Date': 'इनवॉइस तिथि',
  'Customer Name': 'ग्राहक का नाम',
  'Mode of Payment': 'भुगतान का माध्यम',
  'CGST Amount': 'CGST राशि',
  'SGST Amount': 'SGST राशि',
  'Total of Invoice': 'इनवॉइस की कुल राशि',
  'GST Codes': 'GST कोड्स',
  'Report Summary': 'रिपोर्ट सारांश',
  'Total Entries': 'कुल प्रविष्टियाँ',
  'Total Payments': 'कुल भुगतान',
  'Total CGST': 'कुल CGST',
  'Total SGST': 'कुल SGST',
  'Attendance Report Generator': 'उपस्थिति रिपोर्ट जनरेटर',
  'Month': 'महीना',
  'Year': 'वर्ष',
  'Attendance Summary ({count} customers)': 'उपस्थिति सारांश ({count} ग्राहक)',
  'Present Days': 'उपस्थित दिन',
  'Absent Days': 'अनुपस्थित दिन',
  'Attendance %': 'उपस्थिति %',
  'Total Customers': 'कुल ग्राहक',
  'Total Present': 'कुल उपस्थित',
  'Total Absent': 'कुल अनुपस्थित',
  'Days in Month': 'महीने के दिन',
  'Profit & Volume Points Report': 'लाभ और वॉल्यूम पॉइंट्स रिपोर्ट',
  'Profit Analysis Report': 'लाभ विश्लेषण रिपोर्ट',
  'Total Profit': 'कुल लाभ',
  'Total Volume Points': 'कुल वॉल्यूम पॉइंट्स',
  'Total Cost to Company': 'कुल कॉस्ट टू कंपनी',
  'Revenue in Pipeline': 'पाइपलाइन में रेवेन्यू',
  'Sales in Pipeline': 'पाइपलाइन में बिक्री',
  'Product Cost': 'प्रोडक्ट लागत',
  'Program Cost': 'प्रोग्राम लागत',
  'Program Renewal Profit': 'प्रोग्राम नवीनीकरण संभावित लाभ',
  'Program Renewal Sales': 'प्रोग्राम नवीनीकरण बिक्री',
  'Payment Due': 'भुगतान बकाया',
  'Membership Discounts': 'मेंबरशिप डिस्काउंट्स',
  'Custom Discounts': 'कस्टम डिस्काउंट्स',
  'Profit Distribution': 'लाभ वितरण',
  'No profit data available for this period': 'इस अवधि के लिए लाभ डेटा उपलब्ध नहीं है',
  'Product Sales': 'प्रोडक्ट बिक्री',
  'Program Sales': 'प्रोग्राम बिक्री',
  'Service Sales': 'सर्विस बिक्री',
  'Services': 'सर्विसेस',
  'Volume Points Distribution': 'वॉल्यूम पॉइंट्स वितरण',
  'No volume points data available for this period': 'इस अवधि के लिए वॉल्यूम पॉइंट्स डेटा उपलब्ध नहीं है',
  'Discount Distribution': 'डिस्काउंट वितरण',
  'No discount data available for this period': 'इस अवधि के लिए डिस्काउंट डेटा उपलब्ध नहीं है',
  'Detailed Breakdown': 'विस्तृत विवरण',
  'Profit Margins': 'लाभ मार्जिन',
  'Discount Breakdown': 'डिस्काउंट विवरण',
  'Cost to Company Breakdown': 'कॉस्ट टू कंपनी विवरण',
  'Pipeline Breakdown': 'पाइपलाइन विवरण',
  'Program Renewal Revenue': 'प्रोग्राम नवीनीकरण रेवेन्यू',
  'Pending Dues': 'लंबित बकाया',
  'Total Pipeline Revenue': 'कुल पाइपलाइन रेवेन्यू',
  'Membership': 'मेंबरशिप',
  'Custom': 'कस्टम',
  'My Customers': 'मेरे ग्राहक',
  'Affiliated Customers': 'संबद्ध ग्राहक',
  'From affiliated clubs': 'संबद्ध क्लबों से',
  'First Line Supervisors': 'प्रथम पंक्ति सुपरवाइज़र',
  'All Line Supervisors': 'सभी पंक्ति सुपरवाइज़र',
  'Org Tree View': 'संगठन ट्री दृश्य',
  "Today's Checkup": 'आज की जांच',
  "Today's Birthday": 'आज के जन्मदिन',
  "Today's Followups": 'आज के फॉलो-अप',
  "Today's Lead Followups": 'आज के लीड फॉलो-अप',
  'Upcoming Followups': 'आगामी फॉलो-अप',
  'Upcoming Followups (Next 7 Days)': 'आगामी फॉलो-अप (अगले 7 दिन)',
  'Customer Followup': 'ग्राहक फॉलो-अप',
  'Lead Followup': 'लीड फॉलो-अप',
  'Customer Acquisition': 'ग्राहक अधिग्रहण',
  'Customer Acquisition Report': 'ग्राहक अधिग्रहण रिपोर्ट',
  'Analyze customer growth from actively subscribed coaches across your hierarchy': 'पूरे पदानुक्रम में सक्रिय सदस्यता वाले कोचों के ग्राहक वृद्धि का विश्लेषण करें',
  'Track new customers by month and coach ownership.': 'माह और कोच के अनुसार नए ग्राहकों को ट्रैक करें।',
  'Report Scope': 'रिपोर्ट का दायरा',
  'Self': 'स्वयं',
  'Org': 'संगठन',
  'My customers (active subscription)': 'मेरे ग्राहक (सक्रिय सदस्यता)',
  "Customers of active descendant coaches": 'सक्रिय अधीनस्थ कोचों के ग्राहक',
  'From Month': 'प्रारंभ माह',
  'To Month': 'अंतिम माह',
  'Start month cannot be after end month': 'प्रारंभ माह अंतिम माह के बाद नहीं हो सकता',
  'Failed to generate customer acquisition report. Please try again.': 'ग्राहक अधिग्रहण रिपोर्ट तैयार नहीं हो सकी। कृपया फिर प्रयास करें।',
  'New Customers': 'नए ग्राहक',
  'Monthly Average': 'मासिक औसत',
  'Leading Coach': 'अग्रणी कोच',
  'Selected Period': 'चयनित अवधि',
  'Monthly Acquisition Trend': 'मासिक ग्राहक वृद्धि',
  'New customers created in each selected month': 'प्रत्येक चयनित माह में बनाए गए नए ग्राहक',
  'Monthly customer acquisition bar chart': 'मासिक ग्राहक अधिग्रहण बार चार्ट',
  'Acquisition by Coach': 'कोच के अनुसार अधिग्रहण',
  'Contribution across the complete coach hierarchy': 'पूरे कोच पदानुक्रम का योगदान',
  'No descendant coaches found.': 'कोई अधीनस्थ कोच नहीं मिला।',
  'New Customer Details': 'नए ग्राहक का विवरण',
  '{count} customers in the selected period': 'चयनित अवधि में {count} ग्राहक',
  'No new customers found for the selected period and scope.': 'चयनित अवधि और दायरे में कोई नया ग्राहक नहीं मिला।',
  'Contact': 'संपर्क',
  'Coach': 'कोच',
  'Online': 'ऑनलाइन',
  'Online Clients': 'ऑनलाइन ग्राहक',
  'Club Clients': 'क्लब ग्राहक',
  'Type Not Set': 'प्रकार निर्धारित नहीं',
  'Not Set': 'निर्धारित नहीं',
  'Customer type legend': 'ग्राहक प्रकार संकेत',
  'Renewal Due': 'नवीनीकरण देय',
  'Renewal Due (Next 7 Days)': 'नवीनीकरण देय (अगले 7 दिन)',
  'Due Payments': 'बकाया भुगतान',
  'QR Attendance Marker': 'QR उपस्थिति मार्कर',
  'Generate QR for attendance': 'उपस्थिति के लिए QR बनाएं',
  'Attendance Marker': 'उपस्थिति मार्कर',
  'Failed to generate QR code. Please ensure your company information is set up.': 'QR कोड जनरेट नहीं हो सका। कृपया सुनिश्चित करें कि आपकी कंपनी जानकारी सेटअप है।',
  'Failed to load customers. Please try again.': 'ग्राहकों को लोड नहीं किया जा सका। कृपया फिर से प्रयास करें।',
  'Failed to download instructions PDF. Please try again.': 'निर्देश PDF डाउनलोड नहीं हो सका। कृपया फिर से प्रयास करें।',
  'Failed to mark attendance for today. Please try again.': 'आज की उपस्थिति दर्ज नहीं हो सकी। कृपया फिर से प्रयास करें।',
  'Please select a customer and at least one date': 'कृपया एक ग्राहक और कम से कम एक तारीख चुनें',
  'Attendance marked successfully for selected dates!': 'चुनी गई तारीखों के लिए उपस्थिति सफलतापूर्वक दर्ज की गई!',
  'Attendance de-marked successfully for selected dates!': 'चुनी गई तारीखों के लिए उपस्थिति सफलतापूर्वक हटाई गई!',
  'Failed to mark attendance. Please try again.': 'उपस्थिति दर्ज नहीं हो सकी। कृपया फिर से प्रयास करें।',
  'Failed to de-mark attendance. Please try again.': 'उपस्थिति हटाई नहीं जा सकी। कृपया फिर से प्रयास करें।',
  'Generating attendance QR code...': 'उपस्थिति QR कोड जनरेट किया जा रहा है...',
  'Attendance QR Code': 'उपस्थिति QR कोड',
  'QR Code Details': 'QR कोड विवरण',
  "Today's Date": 'आज की तारीख',
  'Permanent QR. No daily printing required.': 'स्थायी QR। रोज़ प्रिंट की आवश्यकता नहीं है।',
  'Download Instructions PDF': 'निर्देश PDF डाउनलोड करें',
  'Mark Attendance': 'उपस्थिति दर्ज करें',
  'De-Mark Attendance': 'उपस्थिति हटाएं',
  'Permanent QR Code - Valid Every Day': 'स्थायी QR कोड - हर दिन मान्य',
  'Customers Present Today ({count})': 'आज उपस्थित ग्राहक ({count})',
  'Search present...': 'उपस्थित खोजें...',
  'No matching attendance found.': 'मिलती-जुलती उपस्थिति नहीं मिली।',
  'No attendance recorded yet for today.': 'आज के लिए अभी तक कोई उपस्थिति दर्ज नहीं हुई है।',
  'Present': 'उपस्थित',
  'Yet To Mark Today ({count})': 'आज अभी दर्ज होना बाकी ({count})',
  'Search pending...': 'लंबित खोजें...',
  'No matching customers found.': 'मिलते-जुलते ग्राहक नहीं मिले।',
  'All active club customers have marked attendance today.': 'सभी सक्रिय क्लब ग्राहकों ने आज उपस्थिति दर्ज कर ली है।',
  'Marking...': 'दर्ज किया जा रहा है...',
  'Mark Today': 'आज दर्ज करें',
  'Manually Mark Attendance': 'मैन्युअली उपस्थिति दर्ज करें',
  'Manually De-Mark Attendance': 'मैन्युअली उपस्थिति हटाएं',
  'Search Customer': 'ग्राहक खोजें',
  'Search by name, email, or phone...': 'नाम, ईमेल या फोन से खोजें...',
  'Selected Customer': 'चयनित ग्राहक',
  'Select Date(s)': 'तारीख चुनें',
  'Selected Dates ({count})': 'चयनित तिथियाँ ({count})',
  'De-marking...': 'हटाया जा रहा है...',
  'Product Management': 'उत्पाद प्रबंधन',
  'Document Management': 'दस्तावेज़ प्रबंधन',
  'Access Management': 'एक्सेस प्रबंधन',
  'Pending Promotion Requests': 'लंबित पदोन्नति अनुरोध',
  'Lead Management': 'लीड प्रबंधन',
  'Meal Plan Templates': 'मील प्लान टेम्पलेट्स',
  'Training Videos Management': 'प्रशिक्षण वीडियो प्रबंधन',
  'Leaderboard': 'लीडरबोर्ड',
  'Challenge Management': 'चैलेंज प्रबंधन',
  'Challenges': 'चैलेंजेस',
  'My Dashboard': 'मेरा डैशबोर्ड',
  'Manage Associates': 'सहयोगियों का प्रबंधन',
  'Platform Invoices Management': 'प्लेटफ़ॉर्म इनवॉइस प्रबंधन',
  'Subscription Invoices Management': 'सदस्यता इनवॉइस प्रबंधन',
  'Language': 'भाषा',
  'Toggle mobile menu': 'मोबाइल मेनू बदलें',
  'Close': 'बंद करें',
  'Cancel': 'रद्द करें',
  'Save': 'सहेजें',
  'Save Changes': 'परिवर्तन सहेजें',
  'Saving...': 'सहेजा जा रहा है...',
  'Add': 'जोड़ें',
  'Add More': 'और जोड़ें',
  'Edit': 'संपादित करें',
  'Delete': 'हटाएँ',
  'Deleting...': 'हटाया जा रहा है...',
  'Remove': 'निकालें',
  'Refresh': 'रीफ्रेश करें',
  'Retry': 'फिर प्रयास करें',
  'Submit': 'जमा करें',
  'Search': 'खोजें',
  'Search...': 'खोजें...',
  'Type to search...': 'खोजने के लिए टाइप करें...',
  'Clear selection': 'चयन साफ करें',
  'Actions': 'कार्रवाइयाँ',
  'Action': 'कार्रवाई',
  'Status': 'स्थिति',
  'Active': 'सक्रिय',
  'Inactive': 'निष्क्रिय',
  'Archived': 'संग्रहीत',
  'Pending': 'लंबित',
  'Approved': 'स्वीकृत',
  'Rejected': 'अस्वीकृत',
  'Customer': 'ग्राहक',
  'Customers': 'ग्राहक',
  'Member': 'सदस्य',
  'Members': 'सदस्य',
  'Participant': 'प्रतिभागी',
  'Participants': 'प्रतिभागी',
  'Name': 'नाम',
  'First Name': 'पहला नाम',
  'Last Name': 'अंतिम नाम',
  'Username': 'यूज़रनेम',
  'Gender': 'लिंग',
  'Phone': 'फ़ोन',
  'Address': 'पता',
  'Age': 'आयु',
  'Date of Birth': 'जन्म तिथि',
  'Weight': 'वज़न',
  'Height': 'लंबाई',
  'Email': 'ईमेल',
  'Type': 'प्रकार',
  'Description': 'विवरण',
  'Category': 'श्रेणी',
  'Amount': 'राशि',
  'Notes': 'टिप्पणियाँ',
  'Date': 'तिथि',
  'Created': 'निर्मित',
  'Uploaded': 'अपलोड किया गया',
  'Joined': 'जुड़ा',
  'Start Date': 'आरंभ तिथि',
  'End Date': 'समाप्ति तिथि',
  'Program': 'प्रोग्राम',
  'Programs': 'प्रोग्राम',
  'Health Readings': 'हेल्थ रीडिंग्स',
  'Invoices': 'इनवॉइस',
  'Health Reports': 'हेल्थ रिपोर्ट्स',
  'Meal Plan': 'मील प्लान',
  'Referrals': 'रेफ़रल्स',
  'Loading customer details...': 'ग्राहक विवरण लोड हो रहे हैं...',
  'Back to Customers': 'ग्राहकों पर वापस जाएं',
  'Customer Details': 'ग्राहक विवरण',
  'Customer Information': 'ग्राहक जानकारी',
  'Promote To Coach': 'कोच में पदोन्नत करें',
  'Club Change': 'क्लब बदलें',
  'Edit Customer': 'ग्राहक संपादित करें',
  'Personal Details': 'व्यक्तिगत विवरण',
  'Account Details': 'खाता विवरण',
  'Program Details': 'प्रोग्राम विवरण',
  'GST Number': 'GST नंबर',
  'Discomforts & Medications': 'असुविधाएं और दवाइयां',
  'PC ID/Associate ID': 'PC ID/असोसिएट ID',
  'Referred By': 'संदर्भित किया गया',
  'Active Program': 'सक्रिय प्रोग्राम',
  'No Active Program': 'कोई सक्रिय प्रोग्राम नहीं',
  'Checkup Day': 'चेकअप दिवस',
  'Program Discount': 'प्रोग्राम छूट',
  'Product Discount': 'प्रोडक्ट छूट',
  'Basic': 'बेसिक',
  'Basic (MRP)': 'बेसिक (MRP)',
  'N/A': 'लागू नहीं',
  'Failed to load your details. Please try again.': 'आपके विवरण लोड नहीं हो सके। कृपया फिर से प्रयास करें।',
  'Meal plan link is missing': 'मील प्लान लिंक उपलब्ध नहीं है',
  'Failed to open meal plan. Please try again.': 'मील प्लान नहीं खुल सका। कृपया फिर से प्रयास करें।',
  'Failed to download document. Please try again.': 'दस्तावेज़ डाउनलोड नहीं हो सका। कृपया फिर से प्रयास करें।',
  'Failed to download invoice. Please try again.': 'इनवॉइस डाउनलोड नहीं हो सका। कृपया फिर से प्रयास करें।',
  'Failed to download health report. Please try again.': 'हेल्थ रिपोर्ट डाउनलोड नहीं हो सकी। कृपया फिर से प्रयास करें।',
  'Reading date and weight are required.': 'रीडिंग तिथि और वजन आवश्यक हैं।',
  'Failed to add health reading. Please try again.': 'हेल्थ रीडिंग जोड़ी नहीं जा सकी। कृपया फिर से प्रयास करें।',
  'Loading your dashboard...': 'आपका डैशबोर्ड लोड हो रहा है...',
  'My Information': 'मेरी जानकारी',
  'Email': 'ईमेल',
  'Phone': 'फोन',
  'Gender': 'लिंग',
  'Address': 'पता',
  'Customer Type': 'ग्राहक प्रकार',
  'ONLINE': 'ऑनलाइन',
  'CLUB': 'क्लब',
  'MALE': 'पुरुष',
  'FEMALE': 'महिला',
  'ACTIVE': 'सक्रिय',
  'INACTIVE': 'निष्क्रिय',
  'BLOCKED': 'ब्लॉक किया गया',
  'PAID': 'भुगतान किया गया',
  'PENDING': 'लंबित',
  'OVERDUE': 'अतिदेय',
  'CANCELLED': 'रद्द',
  'My Health Readings': 'मेरी हेल्थ रीडिंग्स',
  'Add Reading': 'रीडिंग जोड़ें',
  'No health readings found. Click "Add Reading" to record your first health reading.': 'कोई हेल्थ रीडिंग्स नहीं मिलीं। अपनी पहली हेल्थ रीडिंग दर्ज करने के लिए "रीडिंग जोड़ें" पर क्लिक करें।',
  'No health readings found. Your coach will add readings after your checkups.': 'कोई हेल्थ रीडिंग्स नहीं मिलीं। आपका कोच चेकअप के बाद रीडिंग्स जोड़ेंगे।',
  'Weight (kg)': 'वजन (कि.ग्रा.)',
  'Visceral Fat': 'विसरल फैट',
  'Total Fat (%)': 'कुल फैट (%)',
  'Meta Age': 'मेटा एज',
  'Skeletal Muscle (%)': 'स्केलेटल मसल (%)',
  'TSF': 'TSF',
  'TSF (mm)': 'TSF (मिमी)',
  'Date': 'तिथि',
  'Description': 'विवरण',
  'Amount': 'राशि',
  'Due Date': 'देय तिथि',
  'Actions': 'क्रियाएं',
  '{count} payment(s) • Balance: ₹{amount}': '{count} भुगतान • शेष: ₹{amount}',
  'Paid: ₹{amount}': 'भुगतान: ₹{amount}',
  'Download PDF': 'PDF डाउनलोड करें',
  'Download': 'डाउनलोड करें',
  'My Invoices': 'मेरे इनवॉइस',
  'No invoices found.': 'कोई इनवॉइस नहीं मिले।',
  'Referals': 'रेफ़रल्स',
  'My Referals': 'मेरे रेफ़रल्स',
  'Loading referals...': 'रेफ़रल्स लोड हो रहे हैं...',
  'No referals found.': 'कोई रेफ़रल्स नहीं मिले।',
  'Name': 'नाम',
  'My Health Library': 'मेरी हेल्थ लाइब्रेरी',
  'Access documents and resources for {customerType} members': '{customerType} सदस्यों के लिए दस्तावेज़ और संसाधन देखें',
  'Loading documents...': 'दस्तावेज़ लोड हो रहे हैं...',
  'No documents available for {customerType} members at the moment.': 'फिलहाल {customerType} सदस्यों के लिए कोई दस्तावेज़ उपलब्ध नहीं हैं।',
  'Health Videos ({count})': 'हेल्थ वीडियो ({count})',
  'Added by {name} • {date}': '{name} द्वारा जोड़ा गया • {date}',
  'Watch Video': 'वीडियो देखें',
  'Watch': 'देखें',
  'Documents ({count})': 'दस्तावेज़ ({count})',
  'Document': 'दस्तावेज़',
  'Category': 'श्रेणी',
  'Action': 'क्रिया',
  'No description': 'कोई विवरण नहीं',
  'Download Document': 'दस्तावेज़ डाउनलोड करें',
  'No documents or videos available for {customerType} members at the moment.': 'फिलहाल {customerType} सदस्यों के लिए कोई दस्तावेज़ या वीडियो उपलब्ध नहीं हैं।',
  'No health reports found. Your coach will generate reports based on your health readings.': 'कोई हेल्थ रिपोर्ट्स नहीं मिलीं। आपका कोच आपकी हेल्थ रीडिंग्स के आधार पर रिपोर्ट बनाएंगे।',
  'No programs assigned yet. Your coach will assign programs based on your goals.': 'अभी तक कोई प्रोग्राम असाइन नहीं किया गया है। आपका कोच आपके लक्ष्यों के आधार पर प्रोग्राम असाइन करेंगे।',
  'My Cashback Wallet': 'मेरा कैशबैक वॉलेट',
  'Total Earned: ₹{earned} | Total Used: ₹{used}': 'कुल कमाई: ₹{earned} | कुल उपयोग: ₹{used}',
  'Loading cashback data...': 'कैशबैक डेटा लोड हो रहा है...',
  'Cashback Earned ({count})': 'प्राप्त कैशबैक ({count})',
  'No cashback earned yet. Refer friends to earn cashback!': 'अभी तक कोई कैशबैक नहीं मिला। दोस्तों को रेफ़र करें और कैशबैक कमाएँ!',
  'Referral': 'रेफ़रल',
  'Cashback Used ({count})': 'उपयोग किया गया कैशबैक ({count})',
  'No cashback used yet.': 'अभी तक कोई कैशबैक उपयोग नहीं किया गया है।',
  'Used for Invoice': 'इनवॉइस के लिए उपयोग किया गया',
  'No meal plans assigned yet. Your coach will assign meal plans based on your goals and preferences.': 'अभी तक कोई मील प्लान असाइन नहीं किया गया है। आपका कोच आपके लक्ष्यों और पसंद के आधार पर मील प्लान असाइन करेंगे।',
  'Open': 'खोलें',
  'Reading Date': 'रीडिंग तिथि',
  'BMR (kcal)': 'BMR (kcal)',
  'Metabolic Age': 'मेटाबॉलिक एज',
  'Male Leaders': 'पुरुष लीडर्स',
  'Female Leaders': 'महिला लीडर्स',
  'Online Male Leaders': 'ऑनलाइन पुरुष लीडर्स',
  'Club Male Leaders': 'क्लब पुरुष लीडर्स',
  'Online Female Leaders': 'ऑनलाइन महिला लीडर्स',
  'Club Female Leaders': 'क्लब महिला लीडर्स',
  'Full leaderboard list ranked by {metric} for this category.': 'इस श्रेणी के लिए {metric} के आधार पर रैंक की गई पूरी लीडरबोर्ड सूची।',
  'weight loss': 'वजन घटाव',
  'percentage of weight loss': 'वजन घटाव प्रतिशत',
  'Best Weight Loss': 'सबसे अच्छा वजन घटाव',
  'Best % Loss': 'सबसे अच्छा % घटाव',
  'Loading members...': 'सदस्य लोड हो रहे हैं...',
  'No members found for this category.': 'इस श्रेणी के लिए कोई सदस्य नहीं मिले।',
  'Latest three weight entries are shown as week1, week2, and week3.': 'नवीनतम तीन वज़न प्रविष्टियाँ week1, week2 और week3 के रूप में दिखाई जाती हैं।',
  'Total': 'कुल',
  'Rank': 'रैंक',
  'Participant': 'प्रतिभागी',
  'Start Weight': 'शुरुआती वजन',
  'End Weight': 'अंतिम वजन',
  'Weight Loss': 'वजन घटाव',
  '% Loss': '% घटाव',
  'Week1': 'सप्ताह1',
  'Week2': 'सप्ताह2',
  'Week3': 'सप्ताह3',
  'Top 3 Transformation Leaders': 'टॉप 3 ट्रांसफॉर्मेशन लीडर्स',
  'Premium podium view for the strongest weight-loss results in this challenge category.': 'इस चैलेंज श्रेणी में सबसे मजबूत वजन घटाव परिणामों के लिए प्रीमियम पोडियम दृश्य।',
  'Rank #{rank}': 'रैंक #{rank}',
  'Drill down': 'विस्तार देखें',
  'Loading leaders...': 'लीडर्स लोड हो रहे हैं...',
  'No qualifying customers found for this range.': 'इस सीमा के लिए कोई पात्र ग्राहक नहीं मिले।',
  'Loss': 'घटाव',
  'ALL': 'सभी',
  'Failed to load leaderboard.': 'लीडरबोर्ड लोड नहीं हो सका।',
  'Failed to load members.': 'सदस्य लोड नहीं हो सके।',
  'Leaderboard Details': 'लीडरबोर्ड विवरण',
  'Track top customer weight loss in the challenge leaderboard.': 'चैलेंज लीडरबोर्ड में शीर्ष ग्राहकों के वजन घटाव को ट्रैक करें।',
  'Track top customer weight loss across club, org, and challenge views.': 'क्लब, ऑर्ग और चैलेंज व्यूज़ में शीर्ष ग्राहकों के वजन घटाव को ट्रैक करें।',
  'Club Level': 'क्लब स्तर',
  'Org Level': 'ऑर्ग स्तर',
  'Challenge Level': 'चैलेंज स्तर',
  'Challenge Date Range': 'चैलेंज तिथि सीमा',
  'Select a challenge': 'एक चैलेंज चुनें',
  'Loading challenges...': 'चैलेंजेस लोड हो रहे हैं...',
  'No challenges available.': 'कोई चैलेंज उपलब्ध नहीं है।',
  'Club Level Leaders': 'क्लब स्तर लीडर्स',
  'Org Level Leaders': 'ऑर्ग स्तर लीडर्स',
  'Back to Dashboard': 'डैशबोर्ड पर वापस जाएं',
  'Reshare Invoice on WhatsApp': 'WhatsApp पर इनवॉइस फिर से साझा करें',
  'Invoice reshared successfully over WhatsApp.': 'इनवॉइस सफलतापूर्वक WhatsApp पर फिर से साझा किया गया।',
  'Failed to reshare invoice over WhatsApp. Please try again.': 'इनवॉइस को WhatsApp पर फिर से साझा नहीं किया जा सका। कृपया फिर से प्रयास करें।',
  'years': 'वर्ष',
  'Customer Meal Plans': 'ग्राहक मील प्लान',
  'Add Meal Plan': 'मील प्लान जोड़ें',
  'Loading meal plans...': 'मील प्लान लोड हो रहे हैं...',
  'No meal plans found. Click "Add Meal Plan" to create the first meal plan.': 'कोई मील प्लान नहीं मिले। पहला मील प्लान बनाने के लिए "मील प्लान जोड़ें" पर क्लिक करें।',
  'Customer Referrals': 'ग्राहक रेफ़रल्स',
  'Loading referrals...': 'रेफ़रल्स लोड हो रहे हैं...',
  'No referrals found for this customer.': 'इस ग्राहक के लिए कोई रेफ़रल्स नहीं मिले।',
  'Health Readings History': 'हेल्थ रीडिंग्स इतिहास',
  'Log Monitoring': 'दैनिक लॉग निगरानी',
  'Generate Health Report': 'हेल्थ रिपोर्ट बनाएं',
  'Loading health readings...': 'हेल्थ रीडिंग्स लोड हो रही हैं...',
  'No health readings found. Click "Add Health Reading" to add the first reading.': 'कोई हेल्थ रीडिंग्स नहीं मिलीं। पहली रीडिंग जोड़ने के लिए "हेल्थ रीडिंग जोड़ें" पर क्लिक करें।',
  'Customer Invoices': 'ग्राहक इनवॉइस',
  'Add Invoice': 'इनवॉइस जोड़ें',
  'Loading invoices...': 'इनवॉइस लोड हो रहे हैं...',
  'No invoices found. Click "Add Invoice" to create the first invoice.': 'कोई इनवॉइस नहीं मिले। पहला इनवॉइस बनाने के लिए "इनवॉइस जोड़ें" पर क्लिक करें।',
  'Loading health reports...': 'हेल्थ रिपोर्ट्स लोड हो रही हैं...',
  'No health reports found. Generate your first AI-powered health report from the Health Readings tab.': 'कोई हेल्थ रिपोर्ट्स नहीं मिलीं। हेल्थ रीडिंग्स टैब से अपनी पहली AI-आधारित हेल्थ रिपोर्ट बनाएं।',
  'Assigned Programs': 'असाइन किए गए प्रोग्राम',
  'Assign Program': 'प्रोग्राम असाइन करें',
  'Loading programs...': 'प्रोग्राम लोड हो रहे हैं...',
  'No programs assigned yet. Click "Assign Program" to assign the first program.': 'अभी तक कोई प्रोग्राम असाइन नहीं किया गया है। पहला प्रोग्राम असाइन करने के लिए "प्रोग्राम असाइन करें" पर क्लिक करें।',
  'Create Meal Plan for {name}': '{name} के लिए मील प्लान बनाएं',
  'Select Criteria': 'मानदंड चुनें',
  'User data not available. Please try again.': 'यूज़र डेटा उपलब्ध नहीं है। कृपया फिर से प्रयास करें।',
  'Failed to load complete profile data. Some fields may be empty.': 'पूरा प्रोफ़ाइल डेटा लोड नहीं हो सका। कुछ फ़ील्ड खाली हो सकते हैं।',
  'This email address is already registered': 'यह ईमेल पता पहले से पंजीकृत है',
  'This username is already registered': 'यह यूज़रनेम पहले से पंजीकृत है',
  'Please fix the email validation error before submitting.': 'सबमिट करने से पहले ईमेल वैलिडेशन त्रुटि ठीक करें।',
  'Please fix the username validation error before submitting.': 'सबमिट करने से पहले यूज़रनेम वैलिडेशन त्रुटि ठीक करें।',
  'Failed to update profile. Please try again.': 'प्रोफ़ाइल अपडेट नहीं हो सकी। कृपया फिर से प्रयास करें।',
  'Profile Updated Successfully!': 'प्रोफ़ाइल सफलतापूर्वक अपडेट हो गई!',
  'Your profile information has been updated.': 'आपकी प्रोफ़ाइल जानकारी अपडेट हो गई है।',
  'Loading profile data...': 'प्रोफ़ाइल डेटा लोड हो रहा है...',
  'New Password (leave blank to keep current)': 'नया पासवर्ड (वर्तमान पासवर्ड रखने के लिए खाली छोड़ें)',
  'Updating...': 'अपडेट हो रहा है...',
  'Update Profile': 'प्रोफ़ाइल अपडेट करें',
  "Failed to load today's attendance status. Please try again.": "आज की उपस्थिति स्थिति लोड नहीं हो सकी। कृपया फिर से प्रयास करें।",
  'Please select an image file (PNG, JPG, GIF)': 'कृपया एक इमेज फ़ाइल चुनें (PNG, JPG, GIF)',
  'Logo file size must be less than 5MB': 'लोगो फ़ाइल का आकार 5MB से कम होना चाहिए',
  'Logo will be automatically resized to fit within 240x240 pixels': 'लोगो को 240x240 पिक्सेल के भीतर फिट करने के लिए अपने आप रिसाइज़ किया जाएगा',
  'Invalid FSSAI number': 'अमान्य FSSAI नंबर',
  'Failed to save company information. Please try again.': 'कंपनी जानकारी सेव नहीं हो सकी। कृपया फिर से प्रयास करें।',
  'Are you sure you want to delete the company logo?': 'क्या आप वाकई कंपनी लोगो हटाना चाहते हैं?',
  'Logo deleted successfully': 'लोगो सफलतापूर्वक हटाया गया',
  'Failed to delete logo. Please try again.': 'लोगो हटाया नहीं जा सका। कृपया फिर से प्रयास करें।',
  'Failed to save club affiliation. Please try again.': 'क्लब संबद्धता सेव नहीं हो सकी। कृपया फिर से प्रयास करें।',
  'Company Information Saved Successfully!': 'कंपनी जानकारी सफलतापूर्वक सेव हो गई!',
  'Club Affiliation Updated Successfully!': 'क्लब संबद्धता सफलतापूर्वक अपडेट हो गई!',
  'Your company information has been updated.': 'आपकी कंपनी जानकारी अपडेट हो गई है।',
  'Your club affiliation has been updated.': 'आपकी क्लब संबद्धता अपडेट हो गई है।',
  "Today's Attendance": 'आज की उपस्थिति',
  "Loading today's attendance...": "आज की उपस्थिति लोड हो रही है...",
  'Marked At': 'चिह्नित समय',
  'Company Setup Required': 'कंपनी सेटअप आवश्यक है',
  'Please complete your company information to continue using the platform. This information is required for invoice generation and compliance.': 'प्लेटफ़ॉर्म का उपयोग जारी रखने के लिए कृपया अपनी कंपनी जानकारी पूरी करें। यह जानकारी इनवॉइस जनरेशन और अनुपालन के लिए आवश्यक है।',
  'Complete Setup & Continue': 'सेटअप पूरा करें और आगे बढ़ें',
  'Save Company Information': 'कंपनी जानकारी सेव करें',
  'My Company': 'मेरी कंपनी',
  'Club Affiliation': 'क्लब संबद्धता',
  'Club Affiliation Settings': 'क्लब संबद्धता सेटिंग्स',
  'Club Ownership Type': 'क्लब स्वामित्व प्रकार',
  'Intern Club Owner': 'इंटर्न क्लब ओनर',
  'Select Club Owner': 'क्लब ओनर चुनें',
  'Select a club owner': 'एक क्लब ओनर चुनें',
  'Select the club owner you are affiliated with': 'जिस क्लब ओनर से आप संबद्ध हैं उसे चुनें',
  'Current Club Affiliation': 'वर्तमान क्लब संबद्धता',
  'Affiliated with': 'संबद्ध',
  'You are operating as an independent club owner': 'आप एक स्वतंत्र क्लब ओनर के रूप में कार्य कर रहे हैं',
  'About Club Affiliation': 'क्लब संबद्धता के बारे में',
  'You operate independently and manage your own club': 'आप स्वतंत्र रूप से कार्य करते हैं और अपना क्लब स्वयं संभालते हैं',
  'You are affiliated with another club owner and operate under their guidance': 'आप किसी अन्य क्लब ओनर से संबद्ध हैं और उनके मार्गदर्शन में कार्य करते हैं',
  'Save Affiliation': 'संबद्धता सेव करें',
  'Failed to add payment. Please try again.': 'भुगतान जोड़ा नहीं जा सका। कृपया फिर से प्रयास करें।',
  'You have items in your invoice. Please generate the invoice first or remove all items before switching invoice type.': 'आपके इनवॉइस में आइटम हैं। कृपया इनवॉइस जनरेट करें या प्रकार बदलने से पहले सभी आइटम हटा दें।',
  'Note: You cannot mix products and programs in a single invoice': 'नोट: एक ही इनवॉइस में प्रोडक्ट और प्रोग्राम एक साथ नहीं जोड़े जा सकते',
  'Override with Custom Discount': 'कस्टम डिस्काउंट से ओवरराइड करें',
  'Custom Discount Amount': 'कस्टम डिस्काउंट राशि',
  "This will override customer's program discount slab. Items will be shown at MRP.": 'यह ग्राहक के प्रोग्राम डिस्काउंट स्लैब को ओवरराइड करेगा। आइटम MRP पर दिखाए जाएंगे।',
  'Include Shipping Charges': 'शिपिंग चार्ज शामिल करें',
  'Shipping Charges': 'शिपिंग चार्ज',
  'Shipping charges cannot exceed ₹300': 'शिपिंग चार्ज ₹300 से अधिक नहीं हो सकते',
  'Enter shipping charges (max ₹300)': 'शिपिंग चार्ज दर्ज करें (अधिकतम ₹300)',
  'Maximum shipping charges allowed: ₹300. GST will be calculated at 18% (9% CGST + 9% SGST).': 'अधिकतम शिपिंग चार्ज ₹300 हैं। GST 18% (9% CGST + 9% SGST) के अनुसार गणना किया जाएगा।',
  'off': 'छूट',
  'Basic (0% off)': 'बेसिक (0% छूट)',
  'Basic (MRP pricing)': 'बेसिक (MRP मूल्य)',
  'Select {item}': '{item} चुनें',
  'Search {items}...': '{items} खोजें...',
  'No {items} available': 'कोई {items} उपलब्ध नहीं हैं',
  'No {items} found': 'कोई {items} नहीं मिले',
  'products': 'प्रोडक्ट्स',
  'programs': 'प्रोग्राम्स',
  'Basic (MRP)': 'बेसिक (MRP)',
  'Fixed Price (No Discount)': 'फिक्स्ड प्राइस (कोई डिस्काउंट नहीं)',
  'Basic (0%)': 'बेसिक (0%)',
  'Add Item': 'आइटम जोड़ें',
  'Cashback Wallet': 'कैशबैक वॉलेट',
  'Available Balance': 'उपलब्ध बैलेंस',
  'Modify Cashback': 'कैशबैक बदलें',
  'This amount will be deducted from your cashback balance and applied as discount to the invoice.': 'यह राशि आपके कैशबैक बैलेंस से घटाकर इनवॉइस पर डिस्काउंट के रूप में लागू की जाएगी।',
  'Subtotal (Before {type})': 'सबटोटल ({type} से पहले)',
  'Subtotal (After {type})': 'सबटोटल ({type} के बाद)',
  'Custom Discount': 'कस्टम डिस्काउंट',
  'Cashback': 'कैशबैक',
  'CGST ({rate}%)': 'CGST ({rate}%)',
  'SGST ({rate}%)': 'SGST ({rate}%)',
  'Program/Product Discount': 'प्रोग्राम/प्रोडक्ट डिस्काउंट',
  "Great! You're saving ₹{amount} with cashback discount. GST has been recalculated on the reduced amount.": 'बहुत बढ़िया! आप कैशबैक डिस्काउंट से ₹{amount} बचा रहे हैं। GST कम राशि पर दोबारा गणना किया गया है।',
  'e.g., Monthly program fee': 'उदा., मासिक प्रोग्राम शुल्क',
  'Full Payment': 'पूरा भुगतान',
  'Partial Payment': 'आंशिक भुगतान',
  'No Payment': 'कोई भुगतान नहीं',
  'Select Mode': 'मोड चुनें',
  'Overdue': 'बकाया',
  'Cancelled': 'रद्द',
  'Additional notes...': 'अतिरिक्त नोट्स...',
  'Invoice Details': 'इनवॉइस विवरण',
  'Already Paid': 'पहले से भुगतान',
  'Remaining': 'शेष',
  'Max: ₹{amount}': 'अधिकतम: ₹{amount}',
  'Payment reference, transaction ID, etc.': 'भुगतान संदर्भ, ट्रांजैक्शन आईडी आदि।',
  'Failed to load coaches. Please try again.': 'कोच लोड नहीं हो सके। कृपया फिर से प्रयास करें।',
  'Please select a coach': 'कृपया एक कोच चुनें',
  'Coach requested club change for customer': 'कोच ने ग्राहक के लिए क्लब परिवर्तन का अनुरोध किया',
  'Failed to submit request. Please try again.': 'अनुरोध सबमिट नहीं हो सका। कृपया फिर से प्रयास करें।',
  'Club Change Request Submitted!': 'क्लब परिवर्तन अनुरोध सबमिट हो गया!',
  'Your request has been sent to the Upline Tab Team for approval.': 'आपका अनुरोध अनुमोदन के लिए अपलाइन टैब टीम को भेज दिया गया है।',
  'Request Club Change': 'क्लब परिवर्तन का अनुरोध करें',
  'Club Change Request for {name}': '{name} के लिए क्लब परिवर्तन अनुरोध',
  'This request will be sent to the Upline Tab Team for approval. Once approved:': 'यह अनुरोध अनुमोदन के लिए अपलाइन टैब टीम को भेजा जाएगा। मंजूर होने के बाद:',
  "Customer's coach will be changed to the selected coach": 'ग्राहक का कोच चुने गए कोच में बदल दिया जाएगा',
  "Customer will be moved under the new coach's hierarchy": 'ग्राहक को नए कोच की हायरार्की में स्थानांतरित कर दिया जाएगा',
  "Customer's access and programs will remain the same": 'ग्राहक की पहुंच और प्रोग्राम वही रहेंगे',
  'Current Coach': 'वर्तमान कोच',
  'Your current coach': 'आपका वर्तमान कोच',
  'Select New Coach': 'नया कोच चुनें',
  'Loading coaches...': 'कोच लोड हो रहे हैं...',
  'Select a coach': 'एक कोच चुनें',
  'Reason for Change (Optional)': 'परिवर्तन का कारण (वैकल्पिक)',
  'This request requires approval from the Upline Tab Team. You will be notified once your request is reviewed.': 'इस अनुरोध के लिए अपलाइन टैब टीम की मंजूरी आवश्यक है। आपका अनुरोध समीक्षा के बाद आपको सूचित किया जाएगा।',
  'Submitting...': 'सबमिट हो रहा है...',
  'Submit Request': 'अनुरोध सबमिट करें',
  'Conversion Request Submitted!': 'कन्वर्ज़न अनुरोध सबमिट हो गया!',
  'Transition From Coach to Customer': 'कोच से ग्राहक में परिवर्तन',
  'Your role will be changed from Coach to Customer': 'आपकी भूमिका कोच से ग्राहक में बदल दी जाएगी',
  'You will lose access to coach features and tools': 'आपको कोच फीचर्स और टूल्स की पहुंच नहीं रहेगी',
  'Your immediate customers will be moved to your parent coach': 'आपके सीधे ग्राहक आपके पैरेंट कोच के पास स्थानांतरित कर दिए जाएंगे',
  'You will become a customer under your parent coach': 'आप अपने पैरेंट कोच के तहत ग्राहक बन जाएंगे',
  'This action can be reversed with another promotion request': 'इस कार्रवाई को एक अन्य प्रमोशन अनुरोध से पलटा जा सकता है',
  'This request requires approval from the Upline Tab Team. You will be notified once your request is reviewed. This action will significantly change your account permissions.': 'इस अनुरोध के लिए अपलाइन टैब टीम की मंजूरी आवश्यक है। आपका अनुरोध समीक्षा के बाद आपको सूचित किया जाएगा। यह कार्रवाई आपके खाते की अनुमतियों को काफी बदल देगी।',
  'Please enter a valid cashback amount': 'कृपया मान्य कैशबैक राशि दर्ज करें',
  'Amount cannot exceed your cashback balance of ₹{amount}': 'राशि आपकी ₹{amount} कैशबैक शेष राशि से अधिक नहीं हो सकती',
  'Amount cannot exceed current subtotal of ₹{amount}': 'राशि वर्तमान ₹{amount} सबटोटल से अधिक नहीं हो सकती',
  'Apply Cashback Discount': 'कैशबैक डिस्काउंट लागू करें',
  'Available Cashback Balance': 'उपलब्ध कैशबैक बैलेंस',
  'Current Invoice Subtotal': 'वर्तमान इनवॉइस सबटोटल',
  'Maximum cashback you can apply': 'अधिकतम कैशबैक जो आप लागू कर सकते हैं',
  'Cashback Amount to Apply': 'लागू करने के लिए कैशबैक राशि',
  'Enter amount between ₹0.01 and ₹{amount}': '₹0.01 और ₹{amount} के बीच राशि दर्ज करें',
  'How it works': 'यह कैसे काम करता है',
  'Cashback is applied as a discount to the invoice subtotal': 'कैशबैक इनवॉइस सबटोटल पर छूट के रूप में लागू होता है',
  'This cashback will be deducted from your available balance': 'यह कैशबैक आपके उपलब्ध बैलेंस से घटाया जाएगा',
  'You can modify or remove the cashback before generating the invoice': 'इनवॉइस जनरेट करने से पहले आप कैशबैक को बदल या हटा सकते हैं',
  'Clear Cashback': 'कैशबैक हटाएँ',
  'Apply Cashback': 'कैशबैक लागू करें',
  'Promote Customer to Coach': 'ग्राहक को कोच बनाएं',
  'Important': 'महत्वपूर्ण',
  'Promoting this customer to coach will': 'इस ग्राहक को कोच बनाने पर',
  'Change their role from Customer to Coach': 'उनकी भूमिका ग्राहक से कोच में बदल जाएगी',
  'Grant them access to coach features': 'उन्हें कोच फीचर्स की पहुंच मिलेगी',
  'Allow them to manage their own customers': 'उन्हें अपने ग्राहकों को प्रबंधित करने की अनुमति मिलेगी',
  'This action cannot be easily undone': 'इस कार्रवाई को आसानी से वापस नहीं लिया जा सकता',
  'Are you sure you want to send a promotion request for {name} to become a coach?': 'क्या आप वाकई {name} को कोच बनाने के लिए प्रमोशन अनुरोध भेजना चाहते हैं?',
  'What happens next': 'आगे क्या होगा',
  'Upline Tab Team will receive an email notification': 'अपलाइन टैब टीम को ईमेल सूचना मिलेगी',
  'They will also see a notification in their dashboard': 'उन्हें अपने डैशबोर्ड में भी एक सूचना दिखाई देगी',
  'An approver will review and either approve or reject the request': 'एक अप्रूवर अनुरोध की समीक्षा करके उसे मंजूर या अस्वीकार करेगा',
  'You will be notified of the decision': 'आपको निर्णय की सूचना दी जाएगी',
  'If approved, all customers referred by {name} will become your direct customers': 'यदि मंजूर हुआ, तो {name} द्वारा रेफर किए गए सभी ग्राहक आपके सीधे ग्राहक बन जाएंगे',
  'Promoting...': 'प्रमोशन हो रहा है...',
  'Promote to Coach': 'कोच बनाएं',
  'Assign Program to {name}': '{name} को प्रोग्राम असाइन करें',
  'Select Program': 'प्रोग्राम चुनें',
  'Showing {type} programs only': 'केवल {type} प्रोग्राम दिखाए जा रहे हैं',
  'Comments': 'टिप्पणियाँ',
  'Additional comments about program assignment...': 'प्रोग्राम असाइनमेंट के बारे में अतिरिक्त टिप्पणियाँ...',
  'Assigning...': 'असाइन किया जा रहा है...',
  'Assign Now': 'अभी असाइन करें',
  'Balance Volume Points': 'शेष वॉल्यूम पॉइंट्स',
  'Reason for Stopping Program': 'प्रोग्राम रोकने का कारण',
  'No attendance records found for this program period.': 'इस प्रोग्राम अवधि के लिए कोई उपस्थिति रिकॉर्ड नहीं मिला।',
  'Attendance Dates ({count} days)': 'उपस्थिति तिथियाँ ({count} दिन)',
  "This will send the meal plan link to the customer's WhatsApp number.": 'यह मील प्लान लिंक ग्राहक के व्हॉट्सऐप नंबर पर भेजेगा।',
  'Program Information': 'प्रोग्राम जानकारी',
  'Program Name': 'प्रोग्राम नाम',
  'Program Code': 'प्रोग्राम कोड',
  'Assigned Date': 'असाइन तिथि',
  'Balance Points': 'शेष पॉइंट्स',
  'Assignment Comments': 'असाइनमेंट टिप्पणियाँ',
  'Program Stop Reason': 'प्रोग्राम रोकने का कारण',
  'Stopped on': 'रोकने की तिथि',
  'Program Statistics': 'प्रोग्राम आँकड़े',
  'Total Duration': 'कुल अवधि',
  'Attendance Rate': 'उपस्थिति दर',
  'Points Utilization': 'पॉइंट्स उपयोग',
  'Days Remaining': 'शेष दिन',
  'Program Completed': 'प्रोग्राम पूरा हो गया',
  'Program Expired': 'प्रोग्राम समाप्त हो गया',
  '{count} days': '{count} दिन',
  'Company Information': 'कंपनी जानकारी',
  'GSTIN': 'GSTIN',
  'FSSAI': 'FSSAI',
  'Invoice Date': 'इनवॉइस तिथि',
  'Bill To': 'बिल करें',
  'Discount Plan': 'डिस्काउंट प्लान',
  'Invoice Type': 'इनवॉइस प्रकार',
  'Program Invoice (18% GST)': 'प्रोग्राम इनवॉइस (18% GST)',
  'Product Invoice (5% GST)': 'प्रोडक्ट इनवॉइस (5% GST)',
  'Add Line Items': 'लाइन आइटम जोड़ें',
  'Quantity': 'मात्रा',
  'Discount Applied': 'लागू छूट',
  'Invoice Items': 'इनवॉइस आइटम',
  'Item': 'आइटम',
  'Qty': 'मात्रा',
  'MRP': 'MRP',
  'Discounted Price': 'रियायती मूल्य',
  'Cashback Applied': 'कैशबैक लागू',
  'Invoice Calculations': 'इनवॉइस गणना',
  'Custom Discount Applied': 'कस्टम छूट लागू',
  'Shipping (Base)': 'शिपिंग (मूल)',
  'Shipping CGST (9%)': 'शिपिंग CGST (9%)',
  'Shipping SGST (9%)': 'शिपिंग SGST (9%)',
  'Total Shipping': 'कुल शिपिंग',
  'Total Savings': 'कुल बचत',
  'Final Amount': 'अंतिम राशि',
  'Current Role': 'वर्तमान भूमिका',
  'Code': 'कोड',
  'Duration': 'अवधि',
  'to': 'से',
  'Loading attendance data...': 'उपस्थिति डेटा लोड हो रहा है...',
  'Meal Plan Name': 'मील प्लान नाम',
  'Weight Category': 'वज़न श्रेणी',
  'Food Preference': 'भोजन पसंद',
  'Created Date': 'निर्माण तिथि',
  'Share via WhatsApp': 'व्हॉट्सऐप पर साझा करें',
  'Delete Meal Plan': 'मील प्लान हटाएँ',
  'Weight (kg)': 'वज़न (कि.ग्रा.)',
  'Visceral Fat': 'विसरल फैट',
  'TSF': 'TSF',
  'Total Fat (%)': 'कुल फैट (%)',
  'Meta Age': 'मेटा आयु',
  'BMI': 'BMI',
  'BMR': 'BMR',
  'Skeletal Muscle (%)': 'स्केलेटल मसल (%)',
  'Ideal Values': 'आदर्श मान',
  'Edit Reading': 'रीडिंग संपादित करें',
  'Delete Reading': 'रीडिंग हटाएँ',
  'Invoice #': 'इनवॉइस #',
  'Total Amount': 'कुल राशि',
  'Payment Info': 'भुगतान जानकारी',
  'Due Date': 'देय तिथि',
  '{count} payment(s) made': '{count} भुगतान किए गए',
  'Paid': 'भुगतान किया गया',
  'Total Paid': 'कुल भुगतान',
  'Balance': 'शेष राशि',
  'Last': 'अंतिम',
  'Mode': 'मोड',
  'Add Partial Payment': 'आंशिक भुगतान जोड़ें',
  'Edit Invoice': 'इनवॉइस संपादित करें',
  'Delete Invoice': 'इनवॉइस हटाएँ',
  'Cancel Invoice': 'इनवॉइस रद्द करें',
  'Are you sure you want to cancel this invoice?': 'क्या आप वाकई इस इनवॉइस को रद्द करना चाहते हैं?',
  'Failed to cancel invoice. Please try again.': 'इनवॉइस रद्द नहीं हो सका। कृपया फिर से प्रयास करें।',
  'Report Date': 'रिपोर्ट तिथि',
  'Generated By': 'द्वारा जनरेट किया गया',
  'File Size': 'फ़ाइल आकार',
  'Delete Report': 'रिपोर्ट हटाएँ',
  'Volume Points': 'वॉल्यूम पॉइंट्स',
  'Days Attended': 'उपस्थित दिन',
  'Assigned By': 'द्वारा असाइन किया गया',
  'Consumption / Total': 'उपयोग / कुल',
  'Days Present': 'उपस्थिति दिन',
  'View Program Details': 'प्रोग्राम विवरण देखें',
  'View Attendance': 'उपस्थिति देखें',
  'Stop Program': 'प्रोग्राम रोकें',
  'Stop': 'रोकें',
  'Delete Program': 'प्रोग्राम हटाएँ',
  'Available Templates': 'उपलब्ध टेम्पलेट्स',
  'Meal Plan Details': 'मील प्लान विवरण',
  'Creating...': 'बनाया जा रहा है...',
  'Create Meal Plan': 'मील प्लान बनाएं',
  'Share Meal Plan via WhatsApp': 'व्हॉट्सऐप के जरिए मील प्लान साझा करें',
  'Club': 'क्लब',
  'Company': 'कंपनी',
  'City': 'शहर',
  'State': 'राज्य',
  'Pincode': 'पिनकोड',
  'Payment Date': 'भुगतान तिथि',
  'Payment Mode': 'भुगतान माध्यम',
  'Payment Reference / Notes': 'भुगतान संदर्भ / नोट्स',
  'Amount Paid': 'भुगतान की गई राशि',
  'Add Payment': 'भुगतान जोड़ें',
  'Adding...': 'जोड़ा जा रहा है...',
  'Cash': 'नकद',
  'Card': 'कार्ड',
  'Bank Transfer': 'बैंक ट्रांसफर',
  'Cheque': 'चेक',
  'Net Banking': 'नेट बैंकिंग',
  'Profile': 'प्रोफ़ाइल',
  'Company Settings': 'कंपनी सेटिंग्स',
  'Attendance': 'उपस्थिति',
  'Attendance Marked': 'उपस्थिति दर्ज की गई',
  'Yet To Mark Attendance': 'अभी उपस्थिति दर्ज करनी है',
  'Loading settings...': 'सेटिंग्स लोड हो रही हैं...',
  'Loading...': 'लोड हो रहा है...',
  'Please wait...': 'कृपया प्रतीक्षा करें...',
  'View': 'देखें',
  'Download': 'डाउनलोड करें',
  'Download PDF': 'पीडीएफ डाउनलोड करें',
  'Download Document': 'दस्तावेज़ डाउनलोड करें',
  'Watch Video': 'वीडियो देखें',
  'Open Meal Plan': 'मील प्लान खोलें',
  'Company Name': 'कंपनी का नाम',
  'Phone Number': 'फ़ोन नंबर',
  'Address Line 1': 'पता पंक्ति 1',
  'Address Line 2': 'पता पंक्ति 2',
  'GSTIN Number': 'जीएसटीआईएन नंबर',
  'FSSAI Number': 'एफएसएसएआई नंबर',
  'Company Level': 'कंपनी स्तर',
  'Herbalife Level': 'हर्बालाइफ़ स्तर',
  'Company Logo': 'कंपनी लोगो',
  'Current Logo': 'वर्तमान लोगो',
  'Logo Preview': 'लोगो पूर्वावलोकन',
  'Delete Logo': 'लोगो हटाएँ',
  'Complete Setup & Continue': 'सेटअप पूरा करें और जारी रखें',
  'Save Company Information': 'कंपनी जानकारी सहेजें',
  'Club Affiliation': 'क्लब संबद्धता',
  'Select Affiliation': 'संबद्धता चुनें',
  'Loading today\'s attendance...': 'आज की उपस्थिति लोड हो रही है...',
  'Marked At:': 'दर्ज समय:',
  'My Health Library': 'मेरी हेल्थ लाइब्रेरी',
  'My Health Reports': 'मेरी हेल्थ रिपोर्ट्स',
  'My Programs': 'मेरे प्रोग्राम',
  'My Cashback Wallet': 'मेरा कैशबैक वॉलेट',
  'My Meal Plans': 'मेरे मील प्लान',
  'Add Health Reading': 'हेल्थ रीडिंग जोड़ें',
  'Document': 'दस्तावेज़',
  'Report Date': 'रिपोर्ट तिथि',
  'Generated By': 'द्वारा जनरेट',
  'File Size': 'फ़ाइल आकार',
  'Meal Plan Name': 'मील प्लान नाम',
  'Weight Category': 'वज़न श्रेणी',
  'Food Preference': 'भोजन वरीयता',
  'Created Date': 'निर्माण तिथि',
  'Assigned By': 'द्वारा सौंपा गया',
  'Volume Points': 'वॉल्यूम पॉइंट्स',
  'Days Attended': 'उपस्थित दिन',
  'Product': 'उत्पाद',
  'Products': 'उत्पाद',
  'Search leads...': 'लीड्स खोजें...',
  'Search products...': 'उत्पाद खोजें...',
  'Search affiliated customers...': 'संबद्ध ग्राहकों को खोजें...',
  'Search by name, email, type or gender': 'नाम, ईमेल, प्रकार या लिंग से खोजें',
  'Enter username': 'यूज़रनेम दर्ज करें',
  'Enter phone number': 'फ़ोन नंबर दर्ज करें',
  'No data found.': 'कोई डेटा नहीं मिला।',
  'No records found.': 'कोई रिकॉर्ड नहीं मिला।',
  'Back to Challenges': 'चैलेंजेस पर वापस जाएँ',
  'Challenge not found.': 'चैलेंज नहीं मिला।',
  'Add Users to Challenge': 'चैलेंज में उपयोगकर्ता जोड़ें',
  'Search and select referrer...': 'रेफ़रर खोजें और चुनें...',
  'Additional notes about the lead...': 'लीड के बारे में अतिरिक्त नोट्स...',
  'e.g., Mumbai, Maharashtra': 'जैसे, मुंबई, महाराष्ट्र',
  'e.g., 75.5': 'जैसे, 75.5',
  'e.g., 175.5': 'जैसे, 175.5',
  'Auto-filled from DOB': 'डीओबी से स्वतः भरा गया',
  'e.g., STK001': 'जैसे, STK001',
  'e.g., Protein Powder': 'जैसे, प्रोटीन पाउडर',
  'e.g., 25.50': 'जैसे, 25.50',
  'e.g., 2500.00': 'जैसे, 2500.00',
  'e.g., 2250.00': 'जैसे, 2250.00',
  'e.g., 2000.00': 'जैसे, 2000.00',
  'Inventory Management': 'इन्वेंटरी प्रबंधन',
  'Upload E-invoices and track stock': 'E-invoice अपलोड करें और स्टॉक ट्रैक करें',
  'Track inward stock from E-invoices or manual entries, then mark barcodes outward as stock leaves.': 'E-invoice या मैनुअल एंट्री से inward stock ट्रैक करें, फिर stock निकलने पर barcode को outward चिह्नित करें।',
  'Current stock': 'वर्तमान स्टॉक',
  '{count} product types': '{count} उत्पाद प्रकार',
  'Upload E-invoice PDF': 'E-invoice PDF अपलोड करें',
  'PDF file': 'PDF फ़ाइल',
  'Uploading...': 'अपलोड हो रहा है...',
  'Upload and import': 'अपलोड और इम्पोर्ट करें',
  'Manual inward entry': 'मैनुअल inward एंट्री',
  'SKU': 'SKU',
  'Product name': 'उत्पाद का नाम',
  'Barcodes': 'बारकोड',
  'One per line or comma separated. Leave blank to create manual stock units.': 'एक लाइन में एक या कॉमा से अलग करें। मैनुअल स्टॉक यूनिट बनाने के लिए खाली छोड़ें।',
  'Add inward stock': 'inward stock जोड़ें',
  'Inventory': 'इन्वेंटरी',
  'Search by product name or SKU': 'उत्पाद नाम या SKU से खोजें',
  'Loading inventory...': 'इन्वेंटरी लोड हो रही है...',
  'No stock found.': 'कोई स्टॉक नहीं मिला।',
  'Details': 'विवरण',
  'Uploaded E-invoices': 'अपलोड किए गए E-invoices',
  'No E-invoices uploaded yet.': 'अभी तक कोई E-invoice अपलोड नहीं हुआ है।',
  'File': 'फ़ाइल',
  'Imported': 'इम्पोर्ट किया गया',
  'Page': 'पेज',
  'First matched page': 'पहला मिला हुआ पेज',
  'Uploaded at': 'अपलोड समय',
  '{items} items, {barcodes} barcodes': '{items} आइटम, {barcodes} बारकोड',
  'SKU {sku} | {count} in stock': 'SKU {sku} | स्टॉक में {count}',
  'Loading barcodes...': 'बारकोड लोड हो रहे हैं...',
  'No active barcodes remain for this item.': 'इस आइटम के लिए कोई सक्रिय बारकोड नहीं बचा है।',
  'Barcode': 'बारकोड',
  'Source': 'स्रोत',
  'Inward at': 'Inward समय',
  'E-invoice': 'E-invoice',
  'Manual': 'मैनुअल',
  'Mark outward': 'Outward चिह्नित करें',
  'Confirm outward entry': 'Outward एंट्री की पुष्टि करें',
  'This will reduce stock by 1 and keep the barcode record for compliance.': 'इससे स्टॉक 1 कम होगा और अनुपालन के लिए बारकोड रिकॉर्ड सुरक्षित रहेगा।',
  'SKU {sku}': 'SKU {sku}',
  'Barcode {barcode}': 'बारकोड {barcode}',
  'Confirm outward': 'Outward पुष्टि करें',
  'In stock barcodes': 'स्टॉक में बारकोड',
  'Outward entries': 'आउटवर्ड एंट्रीज़',
  'No outward entries recorded for this item.': 'इस आइटम के लिए कोई outward entry दर्ज नहीं है।',
  'E-invoice outward entries': 'E-invoice outward entries',
  'Loading outward entries...': 'Outward entries लोड हो रही हैं...',
  'No outward entries recorded for this E-invoice.': 'इस E-invoice के लिए कोई outward entry दर्ज नहीं है।',
  'Outward at': 'Outward समय',
  'Reason': 'कारण',
  'Outward reason': 'Outward कारण',
  'Add an optional comment for this outward entry.': 'इस outward entry के लिए वैकल्पिक टिप्पणी जोड़ें।',
  'Delete E-invoice': 'E-invoice हटाएँ',
  'This will delete all entries from inventory for the selected E-invoice. The file will also be removed from S3.': 'इससे चयनित E-invoice की सभी inventory entries हट जाएँगी। फ़ाइल भी S3 से हटाई जाएगी।',
  'E-invoice deleted. Imported inventory entries were removed.': 'E-invoice हट गया। इम्पोर्ट की गई inventory entries हटा दी गईं।',
  'Unable to delete this E-invoice.': 'यह E-invoice हटाया नहीं जा सका।',
  'Unable to load inventory right now.': 'अभी इन्वेंटरी लोड नहीं हो सकी।',
  'Choose a PDF E-invoice before uploading.': 'अपलोड करने से पहले PDF E-invoice चुनें।',
  'E-invoice uploaded. {count} inward entries imported.': 'E-invoice अपलोड हो गया। {count} inward entries इम्पोर्ट हुईं।',
  'Unable to upload and parse this PDF.': 'यह PDF अपलोड और पार्स नहीं हो सकी।',
  'Manual inward entries added.': 'मैनुअल inward entries जोड़ दी गईं।',
  'Unable to save manual inward entries.': 'मैनुअल inward entries सेव नहीं हो सकीं।',
  'Unable to load barcode details.': 'बारकोड विवरण लोड नहीं हो सके।',
  'Outward entry marked. Stock reduced by 1.': 'Outward entry चिह्नित हुई। स्टॉक 1 कम हुआ।',
  'Unable to mark this barcode outward.': 'इस बारकोड को outward चिह्नित नहीं किया जा सका।',
  'Unable to load E-invoice outward entries.': 'E-invoice outward entries लोड नहीं हो सकीं।',
  'Paste QR code URL or UUID here': 'यहाँ QR कोड URL या UUID पेस्ट करें',
  'Track inward and outward stock with customer-level history.': 'Track inward and outward stock with customer-level history.',
  'Current Inventory': 'Current Inventory',
  'Outward Stock': 'Outward Stock',
  'Outward Stock History': 'Outward Stock History',
  'Review stock issued to customers and counter consumption.': 'Review stock issued to customers and counter consumption.',
  'Unable to load outward history.': 'Unable to load outward history.',
  'Unable to search customers.': 'Unable to search customers.',
  'Unable to search inventory.': 'Unable to search inventory.',
  'Counter consumption': 'Counter consumption',
  'Maps to your logged-in account for club consumption.': 'Maps to your logged-in account for club consumption.',
  'Search direct or affiliated customers': 'Search direct or affiliated customers',
  'Select a customer or Counter consumption.': 'Select a customer or Counter consumption.',
  'Add at least one inventory item.': 'Add at least one inventory item.',
  'Outward stock recorded successfully.': 'Outward stock recorded successfully.',
  'Unable to record outward stock.': 'Unable to record outward stock.',
  'No outward transactions found for this date range.': 'No outward transactions found for this date range.',
  'Club use': 'Club use',
  'Create Outward Stock': 'Create Outward Stock',
  'Choose a recipient and add one or more inventory items.': 'Choose a recipient and add one or more inventory items.',
  'Recipient': 'Recipient',
  'Add inventory items': 'Add inventory items',
  'available': 'available',
  'Confirm Outward Stock': 'Confirm Outward Stock',
  'Outward Transaction Details': 'Outward Transaction Details',
  'This will delete imported inventory entries and the uploaded file.': 'This will delete imported inventory entries and the uploaded file.',
  'Edit Product Settlement': 'उत्पाद निपटान संपादित करें',
  'Correct the products, quantities, due date, or comments.': 'उत्पाद, मात्रा, नियत तारीख या टिप्पणियाँ सुधारें।',
  'Update Settlement': 'निपटान अपडेट करें',
  'Unable to update product settlement.': 'उत्पाद निपटान अपडेट नहीं किया जा सका।',
  'Unable to delete product settlement.': 'उत्पाद निपटान हटाया नहीं जा सका।',
  'Deleting this settlement will also delete its return history. Continue?': 'इस निपटान को हटाने से इसका वापसी इतिहास भी हट जाएगा। जारी रखें?',
  'Products with recorded returns cannot be removed.': 'दर्ज वापसी वाले उत्पाद हटाए नहीं जा सकते।',
  'Daily Log Monitoring': 'दैनिक लॉग निगरानी',
  'Submitted today': 'आज जमा किया',
  "Today's Daily Log Monitoring": 'आज की दैनिक लॉग निगरानी',
  'Active Online and Club customers': 'सक्रिय ऑनलाइन और क्लब ग्राहक',
  'Active Customers': 'सक्रिय ग्राहक',
  'Submitted': 'जमा किया',
  'Not Submitted': 'जमा नहीं किया',
  'Daily log submitted': 'दैनिक लॉग जमा किया',
  'Customers below 65% are highlighted for attention.': '65% से कम स्कोर वाले ग्राहकों को ध्यान देने के लिए हाइलाइट किया गया है।',
  'No customers have submitted a daily log today.': 'आज किसी ग्राहक ने दैनिक लॉग जमा नहीं किया है।',
  'Daily log not submitted': 'दैनिक लॉग जमा नहीं किया',
  'Every active customer has submitted a daily log today.': 'हर सक्रिय ग्राहक ने आज दैनिक लॉग जमा किया है।',
  'View Daily Log': 'दैनिक लॉग देखें',
  'Not submitted': 'जमा नहीं किया',
  'Loading daily log status...': 'दैनिक लॉग स्थिति लोड हो रही है...',
  'Unable to load daily log monitoring.': 'दैनिक लॉग निगरानी लोड नहीं की जा सकी।',
  "Yesterday's log submitted": 'कल का लॉग जमा किया',
  "Checking yesterday's log dated {date}": '{date} तारीख के कल के लॉग की जाँच की जा रही है',
  "No customers have submitted yesterday's daily log.": 'किसी ग्राहक ने कल का दैनिक लॉग जमा नहीं किया है।',
  "Every active customer has submitted yesterday's daily log.": 'हर सक्रिय ग्राहक ने कल का दैनिक लॉग जमा किया है।',
};

export default hi;
